/* Marketplace header: "All Categories" panel with hover-switched panes. */
class CategoryNav extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-catnav-trigger]');
    this.panel = this.querySelector('[data-catnav-panel]');
    this.tabs = Array.from(this.querySelectorAll('[data-catnav-tab]'));
    this.panes = Array.from(this.querySelectorAll('[data-catnav-pane]'));
    if (!this.trigger || !this.panel) return;

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    // Click toggles the panel; it stays open until the trigger is clicked again.
    this.trigger.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
    document.addEventListener('keydown', this.onKeydown);

    // Hover (and keyboard focus) on a rail item swaps the right-hand pane.
    this.tabs.forEach((tab) => {
      const activate = () => this.activate(tab.dataset.catnavTab);
      tab.addEventListener('mouseenter', activate);
      tab.addEventListener('focus', activate);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  get isOpen() {
    return !this.panel.hasAttribute('hidden');
  }

  activate(index) {
    this.tabs.forEach((t) => {
      const on = t.dataset.catnavTab === index;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.panes.forEach((p) => p.classList.toggle('is-active', p.dataset.catnavPane === index));
  }

  open() {
    this.panel.removeAttribute('hidden');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.classList.add('is-open');
  }

  close() {
    this.panel.setAttribute('hidden', '');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.classList.remove('is-open');
  }

  onKeydown(event) {
    if (event.code === 'Escape' && this.isOpen) {
      this.close();
      this.trigger.focus();
    }
  }
}

if (!customElements.get('category-nav')) customElements.define('category-nav', CategoryNav);
